import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getApiProgram = (program : string) => {
    return program === "weight-loss" ? "weight_loss" : "urgent_care"
}

export const getRawProgram = (program : string) => {
    return program === "weight_loss" ? "weight-loss" : "urgent-care"
}